import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import BasicModal from '../../../components/modal/BasicModal';

import { deletarServico, fecharModalServico } from '../redux/ServicoActions';

const Remover = () => {
    const dispatch = useDispatch();

    const locales = useSelector(state => state.layoutState.linguagem);
    const defaltText = require(`../nls/${locales}.json`);

    const servico = useSelector(state => state.servicosState.servico);
    const servicos = useSelector((state) => state.servicosState.servicos);
    const paginaAtual = useSelector((state) => state.servicosState.paginacao.pageNumber);

    const statusModal = useSelector(state => state.servicosState.statusModal);

    return (
        <BasicModal
            open={statusModal}
            close={() => dispatch(fecharModalServico())}
            containerModal={{
                title: defaltText.tituloModalRemover,
                size: 'medium',
                content: (
                    <>
                        <p>{defaltText.mensagem.removerConfirmacao}</p>
                        <p style={{ fontWeight: "bold" }}>{servico.nome}</p>
                    </>
                ),
                closeText: defaltText.btn.fechar,
                action: {
                    acao: () => dispatch(deletarServico(servico, servicos.length > 1 ? paginaAtual : (paginaAtual > 0 ? paginaAtual - 1 : paginaAtual))),
                    texto: defaltText.btn.remover,
                    class: "success"
                }
            }}
        />
    );
};

export default Remover;
